<template>
  <div class="questionnaire-content">
    <Icon
      class="questionnaire__icon-back"
      icon="ui-arrow-left"
      @click="setStep('Register')"
    />
    <div class="questionnaire-content__block">
      <p class="questionnaire__title -min-margin-">
        Как узнать свой никнейм?
      </p>
    </div>
    <div class="questionnaire-content__block">
      <List :list="stepList" />
      <List />
    </div>
  </div>
</template>

<script>
import List from './components/List';
export default {
  components: {
    List
  },
  data: () => ({
    stepList: [
      {
        id: 0,
        name: 'Перейди в "Настройки" в меню Telegram.'
      },
      {
        id: 1,
        name: 'Нажми "Изменить профиль"'
      },
      {
        id: 2,
        name: 'В поле "Имя пользователя" введи подходящий никнейм, например @username'
      },
      {
        id: 3,
        name: 'Скопируй его и вставь на предыдущей странице анкеты'
      },
      {
        id: 4,
        hidden: true,
        name: 'Готово, красавчик! :)'
      }
    ]
  }),
  methods: {
    setStep(step) {
      this.$emit('setStep', step);
    }
  }
};
</script>

<style scoped>
.questionnaire__icon-back {
  display: unset;
}
</style>
